<!-- begin::Scroll Top -->
<div mScrollTop id="m_scroll_top" class="m-scroll-top">
	<i class="la la-arrow-up"></i>
</div>
<!-- end::Scroll Top -->
